import { alpha, Theme } from "@mui/material";

export const getPanelStyles = (theme: Theme) => ({
  container: {
    display: "flex",
    flexDirection: "column",
    height: "100%",
    overflow: "hidden",
  },
  tableContainer: {
    flex: 1,
    overflow: "auto",
  },
  paper: {
    p: 2,
    borderRadius: 1,
    backgroundColor: alpha(theme.palette.primary.main, 0.04),
    border: `1px solid ${theme.palette.divider}`,
  },
  header: {
    display: "flex",
    justifyContent: "space-between",
    mb: 2,
  },
  title: {
    fontWeight: 600,
  },
  row: {
    display: "flex",
    justifyContent: "space-between",
  },
  label: {
    color: "text.secondary",
  },
  value: {
    fontWeight: 500,
  },
  divider: {
    my: 1,
  },
  tableRow: {
    "&:hover": {
      backgroundColor: alpha(theme.palette.primary.main, 0.04),
    },
  },
});
